import { enTranslations } from './translations.en';

export const esTranslations: Record<string, string> = {
  ...enTranslations,
  'nav.overview': 'Resumen',
  'nav.overviewDesc': 'Estado operativo, orquestación y canales de entrega',
  'nav.reception': 'Recepción',
  'nav.receptionDesc': 'Listas operativas, emisión manual y carga masiva',
  'nav.administration': 'Administración',
  'nav.administrationDesc':
    'Listas y formularios dedicados para tenants, vendors, ubicaciones, usuarios e infraestructura',
  'shell.consoleTitle': 'Consola operativa',
  'shell.consoleDescription':
    'Panel multi-tenant para flujos PMS, procesos de recepción, aprovisionamiento del controlador de red y distribución DPSK.',
  'shell.livePosture': 'Estado en vivo',
  'shell.loadingLocation': 'Cargando contexto de la ubicación',
  'shell.healthy': 'Flujo operativo correcto',
  'shell.attention': 'Atención en el canal de entrega',
  'shell.authSession': 'Sesión autenticada',
  'shell.guestOperator': 'Operador demo',
  'shell.noRole': 'Sin rol',
  'shell.currentWorkspace': 'Espacio de trabajo actual',
  'shell.workspaceDescription': 'Contexto activo para la página seleccionada.',
  'shell.filters': 'Filtros',
  'shell.tenant': 'Tenant',
  'shell.location': 'Hotel / Ubicación',
  'shell.language': 'Idioma',
  'shell.theme': 'Tema',
  'shell.theme.system': 'Sistema',
  'shell.theme.light': 'Claro',
  'shell.loadingData': 'Actualizando datos',
  'shell.searchTenant': 'Buscar tenant',
  'shell.searchLocation': 'Buscar hotel o ubicación',
  'shell.noSearchResults': 'No hay resultados',
  'shell.closeFilters': 'Cerrar filtros',
  'dialog.cancel': 'Cancelar',
  'dialog.deleteTitle': 'Confirmar eliminación',
  'dialog.extendTitle': 'Confirmar extensión',
  'dialog.revokeTitle': 'Confirmar revocación',
  'shell.noPms': 'Ningún PMS vinculado',
  'shell.noController': 'Ningún controlador vinculado',
  'shell.tvOn': 'TV activa',
  'shell.tvPending': 'TV pendiente',
  'shell.emailOn': 'Correo activo',
  'shell.emailPending': 'Correo pendiente',
  'shell.exitSession': 'Salir',
  'auth.mode.mock': 'Modo demo',
  'login.badge': 'Consola operativa hospitality',
  'login.title': 'Acceso seguro a la plataforma hospitality.',
  'login.description':
    'Gestiona tenants, ubicaciones, usuarios, vendors y credenciales Wi‑Fi desde una única consola pensada para la operación diaria.',
  'login.inputTitle': 'Tenants y ubicaciones',
  'login.inputBody': 'Controla propiedades, unidades, vendors y configuraciones operativas desde un único punto.',
  'login.logicTitle': 'Recepción y credenciales',
  'login.logicBody':
    'Emite, renueva y supervisa códigos Wi‑Fi para huéspedes, personal y eventos sin pasos adicionales.',
  'login.outputTitle': 'Visibilidad operativa',
  'login.outputBody': 'Consulta el estado del servicio, las colas y la entrega de credenciales de un vistazo.',
  'login.accessMode': 'Acceso',
  'login.demoWorkspace': 'Explorar la plataforma',
  'login.keycloakWorkspace': 'Bienvenido de nuevo',
  'login.demoDescription': 'Abre el entorno demo para explorar los flujos principales con datos de ejemplo.',
  'login.keycloakDescription': 'Accede con tu cuenta corporativa para continuar.',
  'login.enterDemo': 'Abrir panel demo',
  'login.continueKeycloak': 'Entrar en la plataforma',
  'login.readyTitle': 'Gestión centralizada',
  'login.readyBody':
    'Tenants, ubicaciones, unidades, usuarios y catálogos están disponibles en una sola consola operativa.',
  'login.supportTitle': 'Operaciones diarias',
  'login.supportBody':
    'Trabaja con los flujos de recepción, las credenciales Wi‑Fi y la configuración del servicio con una experiencia más simple.',
  'login.demoNote': 'El entorno demo usa datos de ejemplo y está pensado solo para exploración.',
  'login.switchNote': 'Si tienes problemas para acceder, contacta con el administrador del servicio.',
  'overview.context': 'Resumen operativo',
  'overview.title': 'Estado de la ubicación seleccionada',
  'overview.subtitle':
    'Indicadores rápidos sobre el uso de DPSK, el mapeo VLAN y la carga operativa del sitio.',
  'reception.pageKicker': 'Operaciones de recepción',
  'reception.pageTitle': 'Emisión de DPSK y gestión del ciclo de vida',
  'reception.pageDescription':
    'El área de recepción se organiza en páginas dedicadas: lista de códigos, emisión manual y carga masiva.',
  'admin.pageKicker': 'Gestión administrativa',
  'admin.pageTitle': 'Tenants, vendors, ubicaciones y usuarios',
  'admin.pageDescription':
    'El área administrativa usa páginas dedicadas para tenants, catálogos vendor, ubicaciones, usuarios e infraestructura.',
  'admin.actions.newRoomAssignment': 'Nueva unidad',
  'admin.actions.assignRoom': 'Editar unidad',
  'admin.form.createRoomAssignment': 'Crear unidad',
  'admin.form.updateRoomAssignment': 'Actualizar unidad',
  'admin.form.roomAssignmentDescription':
    'Define la configuración Wi‑Fi de una sola unidad. La configuración estará disponible de inmediato en el inventario de la ubicación y en los flujos de recepción.',
  'admin.form.roomNotFound': 'Unidad no encontrada.',
  'admin.form.locationRequiredForRoom':
    'Selecciona una ubicación antes de registrar una unidad.',
  'admin.message.roomAssignmentSaved':
    'Configuración de infraestructura guardada para {name}.',
  'table.pagination.previous': 'Anterior',
  'table.pagination.next': 'Siguiente',
  'table.pagination.summary': '{from}-{to} de {total}',
  'app.badge': 'Lumen Hospitality DPSK',
  'auth.mode.keycloak': 'Keycloak',
  'login.realm': 'Realm',
  'login.clientId': 'Client ID',
  'login.endpoint': 'Endpoint',
  'overview.card.active.label': 'Identidades activas',
  'overview.card.active.caption': 'DPSK actualmente válidas en la ubicación seleccionada',
  'overview.card.scheduled.label': 'Llegadas programadas',
  'overview.card.scheduled.caption': 'Credenciales ya creadas y pendientes de check-in o inicio del evento',
  'overview.card.mapped.label': 'Unidades mapeadas',
  'overview.card.mapped.caption': '{rooms} habitaciones, {publicAreas} zonas comunes, {eventHalls} salas de eventos',
  'overview.card.daily.label': 'Volumen diario',
  'overview.card.daily.caption': 'Carga prevista entre PMS, recepción y solicitudes manuales',
  'overview.locationHealth': 'Estado de los servicios',
  'overview.deliveryChannels': 'Canales de entrega',
  'overview.connected': 'Conectado',
  'overview.fallback': 'Fallback activo',
  'overview.accounting': 'Accounting',
  'overview.accountingBody': 'Los registros RADIUS permanecen centralizados para cumplimiento y analítica.',
  'overview.operationalFlow': 'Flujo operativo',
  'overview.flowAligned': 'Alineado con los escenarios del documento',
  'overview.channelMix': 'Mix de canales',
  'overview.distributionSplit': 'Distribución de entrega',
  'overview.channelShare': '{share}% del total visible',
  'overview.infrastructure': 'Unidades y VLAN',
  'overview.infrastructureDesc': 'Habitaciones, zonas comunes y salas de eventos disponibles en esta ubicación.',
  'overview.alerts': 'Panel de alertas',
  'overview.alertsTitle': 'Riesgos y anomalías actuales',
  'overview.noAlerts': 'No hay anomalías abiertas en la ubicación actual.',
  'overview.queue': 'Cola en segundo plano',
  'overview.queueTitle': 'Estado de las importaciones masivas',
  'overview.queueProgress': '{processed}/{total} procesados, VLAN destino {vlan}',
  'overview.credentials': 'Credenciales recientes',
  'overview.credentialsTitle': 'Últimas DPSK emitidas',
  'overview.table.guest': 'Huésped',
  'overview.table.space': 'Unidad',
  'overview.table.type': 'Tipo',
  'overview.table.vlan': 'VLAN',
  'overview.table.ssid': 'SSID',
  'overview.table.panMode': 'Modo PAN',
  'overview.table.source': 'Origen',
  'overview.table.channels': 'Canales',
  'overview.table.validity': 'Validez',
  'overview.table.devices': 'Dispositivos',
  'overview.flow.trigger.title': 'Disparo PMS / recepción',
  'overview.flow.trigger.body': 'Webhook, formulario del operador o CSV generan la solicitud de acceso.',
  'overview.flow.normalize.title': 'Normalización de identidad',
  'overview.flow.normalize.body':
    'La plataforma asigna hotel, unidad, VLAN y ventana temporal de validez.',
  'overview.flow.provision.title': 'Provisioning del controlador de red',
  'overview.flow.provision.body':
    'La DPSK se asocia con la VLAN mapeada y su ciclo de vida.',
  'overview.flow.deliver.title': 'Entrega por canales',
  'overview.flow.deliver.body': 'TV, correo, panel o impresión reciben el QR y la contraseña.',
  'overview.flow.monitor.title': 'Monitorización y accounting',
  'overview.flow.monitor.body':
    'Uso, colas, adopción de canales y accounting siguen visibles para operations.',
  'validation.required': 'Campo obligatorio.',
  'validation.email': 'Introduce un correo electrónico válido.',
  'validation.minValue': 'Introduce un valor válido.',
  'validation.fixErrors': 'Corrige los campos resaltados antes de guardar.',
  'validation.dateOrder': 'La fecha de fin debe ser posterior a la fecha de inicio.',
  'validation.selectOne': 'Selecciona al menos un elemento.',
  'toast.dismiss': 'Cerrar notificación',
  'toast.error.network': 'No se puede contactar con el servicio backend.',
  'toast.error.badRequest': 'La solicitud no es válida.',
  'toast.error.unauthorized': 'Sesión no autorizada. Vuelve a iniciar sesión.',
  'toast.error.forbidden': 'No tienes permisos para completar esta operación.',
  'toast.error.notFound': 'No se ha encontrado el recurso solicitado.',
  'toast.error.conflict': 'La operación no puede completarse por un conflicto de estado.',
  'toast.error.validation': 'Los datos enviados no son válidos.',
  'toast.error.server': 'El servidor ha devuelto un error interno.',
  'toast.error.unavailable': 'El servicio no está disponible temporalmente.',
  'toast.error.genericStatus': 'Error HTTP {status}: la solicitud ha fallado.',
  'toast.error.unexpected': 'Se produjo un error inesperado durante la llamada HTTP.',
  'channel.tv': 'TV',
  'channel.email': 'Correo',
  'channel.dashboard': 'Panel',
  'channel.print': 'Impresión',
  'codeSource.pms': 'PMS',
  'codeSource.reception': 'Recepción',
  'codeSource.bulk': 'Masivo',
  'queueStatus.queued': 'En cola',
  'queueStatus.running': 'En ejecución',
  'queueStatus.completed': 'Completado',
  'queueStatus.attention': 'Atención',
  'spaceKind.room': 'Habitación',
  'spaceKind.public-area': 'Área común',
  'spaceKind.event-hall': 'Sala de eventos',
  'assignment.room': 'Habitación',
  'assignment.group': 'Grupo',
  'assignment.common': 'Común',
  'panMode.private': 'Privado',
  'panMode.shared-group': 'Grupo compartido',
  'panMode.public': 'Común',
  'role.tv-integration': 'Integración TV',
  'role.platform-admin': 'Platform admin',
  'role.tenant-admin': 'Administrador',
  'role.reception': 'Conserjería',
  'role.operations': 'Operations',
  'locationCategory.hotel': 'Hotel',
  'locationCategory.resort': 'Resort',
  'locationCategory.conference': 'Recinto para conferencias',
  'locationState.active': 'Activo',
  'locationState.disabled': 'Deshabilitado',
  'locationState.pending': 'Pendiente',
  'locationState.stable': 'Estable',
  'locationState.attention': 'Atención',
  'unitStatus.available': 'Disponible',
  'unitStatus.disabled': 'Deshabilitada',
  'unitStatus.occupied': 'Ocupada',
  'userStatus.active': 'Activo',
  'userStatus.invited': 'Invitado',
  'userStatus.disabled': 'Deshabilitado',
  'reception.tab.issue': 'Emisión',
  'reception.tab.codes': 'Gestión de códigos',
  'reception.tab.bulk': 'Carga masiva',
  'reception.summary.active': 'Activos',
  'reception.summary.scheduled': 'Programados',
  'reception.summary.archived': 'Archivados',
  'reception.summary.queue': 'Trabajos masivos',
  'reception.issue.kicker': 'Emisión manual',
  'reception.issue.title': 'Crea una DPSK para huéspedes y casos excepcionales',
  'reception.issue.description':
    'Para walk-ins, proveedores, acceso al bar o fallback del PMS. Genera código QR y contraseña en claro.',
  'reception.fields.firstName': 'Nombre',
  'reception.fields.lastName': 'Apellidos',
  'reception.fields.email': 'Correo electrónico',
  'reception.fields.space': 'Unidad',
  'reception.fields.reference': 'Referencia de reserva / voucher',
  'reception.fields.validFrom': 'Válido desde',
  'reception.fields.validUntil': 'Válido hasta',
  'reception.fields.devicesAllowed': 'Dispositivos permitidos',
  'reception.fields.deliveryChannels': 'Canales de entrega',
  'reception.fields.notes': 'Notas del operador',
  'reception.preview.kicker': 'Vista previa del voucher',
  'reception.preview.title': 'Tarjeta del operador',
  'reception.preview.empty': 'Selecciona una unidad para previsualizar el código QR.',
  'reception.preview.guest': 'Huésped',
  'reception.preview.ssidVlan': 'SSID / VLAN',
  'reception.preview.panMode': 'Modo PAN',
  'reception.preview.expires': 'Caducidad',
  'reception.lastCreated': 'Último código creado',
  'reception.lastCreatedEmpty':
    'Genera una DPSK manual para mostrar aquí el último resumen del voucher.',
  'reception.generate': 'Generar DPSK',
  'reception.creating': 'Generando...',
  'reception.codes.kicker': 'Gestión de códigos',
  'reception.codes.title': 'Filtra, amplía o revoca vouchers',
  'reception.filter.all': 'Todos',
  'reception.filter.pms': 'PMS',
  'reception.filter.reception': 'Recepción',
  'reception.filter.bulk': 'Masivo',
  'reception.searchPlaceholder': 'Buscar huésped o referencia',
  'reception.activeList': 'Activos / programados',
  'reception.archivedList': 'Archivados / inválidos',
  'reception.actions.extend': '+24h',
  'reception.actions.revoke': 'Revocar',
  'reception.actions.new': 'Nueva DPSK',
  'reception.actions.backToCodes': 'Volver a los códigos',
  'reception.actions.showQr': 'Mostrar QR',
  'reception.actions.printQr': 'Imprimir QR',
  'reception.confirm.extend': '¿Extender el voucher de {name} 24 horas?',
  'reception.confirm.revoke': '¿Revocar el voucher de {name}?',
  'reception.activeEmpty': 'Ningún código activo o programado coincide con los filtros actuales.',
  'reception.archivedEmpty': 'Ningún código archivado o revocado coincide con los filtros actuales.',
  'reception.bulk.kicker': 'Incorporación masiva',
  'reception.bulk.title': 'Importación CSV para grupos y eventos',
  'reception.bulk.loadFile': 'Cargar archivo',
  'reception.bulk.mode': 'Modo masivo',
  'reception.bulk.modeShared': 'VLAN de grupo compartida',
  'reception.bulk.modeIsolated': 'VLAN / aislamiento por unidad',
  'reception.bulk.defaultSpace': 'Unidad predeterminada',
  'reception.bulk.requestedBy': 'Solicitado por',
  'reception.bulk.csvBody': 'Contenido CSV',
  'reception.bulk.queue': 'Poner en cola la importación',
  'reception.bulk.queueing': 'Poniendo en cola...',
  'reception.bulk.templateHint':
    'Columnas esperadas: firstName, lastName, email, spaceId, validFrom, validUntil, devicesAllowed, bookingReference',
  'reception.bulk.jobs': 'Estado de la cola',
  'reception.bulk.jobsTitle': 'Actividad reciente',
  'reception.emptyLocation': 'Selecciona o crea una ubicación con unidades disponibles.',
  'reception.message.created': 'Creado {id} para {name}.',
  'reception.message.bulkQueued': 'Trabajo {id} puesto en cola con {imported} identidades ({status}).',
  'reception.message.extended': 'Validez extendida para {id} 24 horas.',
  'reception.message.revoked': 'Código {id} revocado.',
  'admin.vendorHintTitle': 'Catálogos de vendors',
  'admin.vendorHintBody':
    'Antes de crear o actualizar una ubicación puedes registrar los catálogos de vendors de controlador y PMS, para que los menús desplegables y los campos de configuración estén listos dentro de los formularios de ubicación.',
  'admin.card.tenants.label': 'Tenants',
  'admin.card.tenants.caption': 'Portafolio multi-tenant gestionado desde el panel',
  'admin.card.locations.label': 'Ubicaciones',
  'admin.card.locations.caption': 'Hoteles, resorts y venues disponibles en el prototipo',
  'admin.card.users.label': 'Usuarios',
  'admin.card.users.caption': 'Roles operativos y asignaciones gestionados mediante el estado mock',
  'admin.card.spaces.label': 'Unidades / VLAN',
  'admin.card.spaces.caption': 'Inventario actual de unidades para la ubicación seleccionada',
  'admin.tab.tenants': 'Tenants',
  'admin.tab.locations': 'Ubicaciones',
  'admin.tab.users': 'Usuarios',
  'admin.tab.controllerVendors': 'Vendors del controlador',
  'admin.tab.pmsVendors': 'Vendors PMS',
  'admin.tab.infrastructure': 'Infraestructura',
  'admin.tenants.kicker': 'Gestión de tenants',
  'admin.tenants.title': 'Crear y actualizar tenants',
  'admin.locations.kicker': 'Gestión de ubicaciones',
  'admin.locations.title': 'Gestiona hoteles, resorts y venues',
  'admin.locations.filterHint':
    'Selecciona un tenant para mostrar solo sus ubicaciones relacionadas, sin usar los filtros operativos globales.',
  'admin.users.kicker': 'Gestión de usuarios',
  'admin.users.title': 'Roles, alcances de tenant y alcances de ubicación',
  'admin.controllerVendors.kicker': 'Catálogo de controladores',
  'admin.controllerVendors.title': 'Registrar y gestionar vendors del controlador',
  'admin.controllerVendors.empty': 'Aún no hay vendors del controlador registrados.',
  'admin.controllerVendors.emptyHint':
    'Añade el primer vendor del controlador para tenerlo disponible durante el alta de ubicaciones.',
  'admin.pmsVendors.kicker': 'Catálogo PMS',
  'admin.pmsVendors.title': 'Registrar y gestionar vendors PMS',
  'admin.pmsVendors.empty': 'Aún no hay vendors PMS registrados.',
  'admin.pmsVendors.emptyHint':
    'Añade el primer vendor PMS para tenerlo disponible durante el alta de ubicaciones.',
  'admin.infrastructure.kicker': 'Inventario e integraciones',
  'admin.infrastructure.title': 'Unidades, VLAN y preparación de conectores',
  'admin.form.new': 'Nuevo',
  'admin.form.reset': 'Restablecer',
  'admin.form.create': 'Crear',
  'admin.form.update': 'Actualizar',
  'admin.form.name': 'Nombre',
  'admin.form.brand': 'Marca / descripción',
  'admin.form.sla': 'SLA',
  'admin.form.coverage': 'Cobertura DPSK %',
  'admin.form.city': 'Ciudad',
  'admin.form.category': 'Categoría',
  'admin.form.pms': 'PMS',
  'admin.form.pmsVendor': 'Vendor PMS',
  'admin.form.pds': 'Configuración PDS',
  'admin.form.controller': 'Controlador',
  'admin.form.controllerVendor': 'Vendor del controlador',
  'admin.form.tv': 'Integración TV',
  'admin.form.email': 'Integración email',
  'admin.form.integrations': 'Integraciones',
  'admin.form.state': 'Estado',
  'admin.form.dailyCheckIns': 'Check-ins diarios',
  'admin.form.activeGuests': 'Huéspedes activos',
  'admin.form.bulkQueue': 'Cola masiva',
  'admin.form.note': 'Nota operativa',
  'admin.form.timezone': 'Zona horaria',
  'admin.form.linkedTenant': 'Tenant asociado',
  'admin.form.role': 'Rol',
  'admin.form.status': 'Estado del usuario',
  'admin.form.tenantScope': 'Alcance del tenant',
  'admin.form.locationScope': 'Alcance de la ubicación',
  'admin.form.fieldSchema': 'Esquema de campos',
  'admin.form.fieldName': 'Nombre del campo',
  'admin.form.fieldType': 'Tipo de campo',
  'admin.form.fieldsHelp': 'Define al menos un campo adicional para el vendor.',
  'admin.form.selectVendor': 'Selecciona vendor',
  'admin.form.selectVendorFirst': 'Selecciona primero un vendor para configurar los campos obligatorios.',
  'admin.form.pmsConfiguration': 'Configuración PMS',
  'admin.form.controllerConfiguration': 'Configuración del controlador',
  'admin.form.vendorConfigurationHint':
    'Completa todos los campos requeridos por la entrada del catálogo vendor seleccionada.',
  'admin.form.noPmsVendorsAvailable':
    'Aún no hay ningún vendor PMS disponible. Registra primero el catálogo PMS.',
  'admin.form.noControllerVendorsAvailable':
    'Aún no hay ningún vendor de controlador disponible. Registra primero el catálogo de controladores.',
  'admin.form.addField': 'Añadir campo',
  'admin.form.removeField': 'Eliminar campo',
  'admin.form.createControllerVendor': 'Crear vendor del controlador',
  'admin.form.createPmsVendor': 'Crear vendor PMS',
  'admin.form.updateControllerVendor': 'Actualizar vendor del controlador',
  'admin.form.updatePmsVendor': 'Actualizar vendor PMS',
  'admin.form.controllerVendorNotFound': 'No se encontró el vendor del controlador.',
  'admin.form.pmsVendorNotFound': 'No se encontró el vendor PMS.',
  'admin.form.vendorFieldType.string': 'Cadena',
  'admin.form.vendorFieldType.number': 'Número',
  'admin.form.vendorFieldType.boolean': 'Booleano',
  'admin.form.vendorFieldType.password': 'Contraseña',
  'admin.form.unitType': 'Tipo de unidad',
  'admin.form.assignment': 'Asignación',
  'admin.form.unitStatus': 'Estado de la unidad',
  'admin.list.portfolio': 'Portafolio',
  'admin.list.properties': 'Propiedades',
  'admin.list.coverage': 'Cobertura',
  'admin.list.alerts': 'Alertas',
  'admin.list.noneTenants': 'Aún no hay tenants registrados.',
  'admin.list.noneLocations': 'No hay ubicaciones disponibles para el tenant seleccionado.',
  'admin.tenants.emptyHint': 'Crea el primer tenant para iniciar el alta multi-tenant de la plataforma.',
  'admin.actions.edit': 'Editar',
  'admin.actions.toggleStatus': 'Cambiar estado',
  'admin.actions.newTenant': 'Nuevo tenant',
  'admin.actions.newLocation': 'Nueva ubicación',
  'admin.actions.newUser': 'Nuevo usuario',
  'admin.actions.newControllerVendor': 'Nuevo vendor del controlador',
  'admin.actions.newPmsVendor': 'Nuevo vendor PMS',
  'admin.actions.manageInfrastructure': 'Infraestructura',
  'admin.actions.backToLocation': 'Volver a la ubicación',
  'admin.actions.backToList': 'Volver a la lista',
  'admin.actions.delete': 'Eliminar',
  'admin.infrastructure.inventory': 'Inventario de unidades',
  'admin.infrastructure.roomAssignments': 'Asignaciones unitarias',
  'admin.infrastructure.roomAssignmentsDesc':
    'Cada habitación se mapea individualmente con SSID, VLAN y modo PAN. Usa esta área para crear o corregir la asignación de una sola habitación.',
  'admin.infrastructure.locationScopeDesc':
    'Esta página pertenece a la ubicación seleccionada. La asignación de infraestructura se gestiona directamente dentro de la ubicación.',
  'admin.infrastructure.sharedSpaces': 'Unidades compartidas y salas de eventos',
  'admin.infrastructure.noRooms': 'No hay ninguna habitación configurada para la ubicación seleccionada.',
  'admin.infrastructure.noSharedSpaces': 'No hay ninguna unidad compartida configurada.',
  'admin.infrastructure.roomPreview': 'Vista previa de la asignación',
  'admin.infrastructure.readiness': 'Preparación de integraciones',
  'admin.integrations.queuePlaceholder': 'Redis / RabbitMQ por definir en backend',
  'admin.integrations.pdsPlaceholder': 'Configuración PDS por definir',
  'admin.form.createTenant': 'Crear tenant',
  'admin.form.updateTenant': 'Actualizar tenant',
  'admin.form.tenantNotFound': 'No se encontró el tenant.',
  'admin.form.createLocation': 'Crear ubicación',
  'admin.form.updateLocation': 'Actualizar ubicación',
  'admin.form.locationNotFound': 'No se encontró la ubicación.',
  'admin.form.createUser': 'Crear usuario',
  'admin.form.updateUser': 'Actualizar usuario',
  'admin.form.userNotFound': 'No se encontró el usuario.',
  'admin.form.roomName': 'Habitación',
  'admin.form.ssid': 'SSID',
  'admin.form.vlanId': 'VLAN',
  'admin.form.serviceVlanId': 'VLAN de servicio',
  'admin.form.networkId': 'ID de red',
  'admin.form.capacity': 'Capacidad',
  'admin.message.tenantSaved': 'Tenant {name} guardado.',
  'admin.message.tenantDeleted': 'Tenant {name} eliminado.',
  'admin.message.locationSaved': 'Ubicación {name} guardada.',
  'admin.message.locationDeleted': 'Ubicación {name} eliminada.',
  'admin.message.userSaved': 'Usuario {name} guardado.',
  'admin.message.userDeleted': 'Usuario {name} eliminado.',
  'admin.message.controllerVendorSaved': 'Vendor del controlador {name} creado.',
  'admin.message.pmsVendorSaved': 'Vendor PMS {name} creado.',
  'admin.message.controllerVendorUpdated': 'Vendor del controlador {name} actualizado.',
  'admin.message.pmsVendorUpdated': 'Vendor PMS {name} actualizado.',
  'admin.message.controllerVendorDeleted': 'Vendor del controlador {name} eliminado.',
  'admin.message.pmsVendorDeleted': 'Vendor PMS {name} eliminado.',
  'admin.message.roomDeleted': 'Habitación {name} eliminada.',
  'admin.confirm.deleteTenant': '¿Eliminar el tenant {name} y todas las ubicaciones vinculadas?',
  'admin.confirm.deleteLocation': '¿Eliminar la ubicación {name} y su infraestructura?',
  'admin.confirm.deleteUser': '¿Eliminar el usuario {name}?',
  'admin.confirm.deleteRoom': '¿Eliminar la habitación {name}?',
  'admin.confirm.deleteControllerVendor': '¿Eliminar el vendor del controlador {name}?',
  'admin.confirm.deletePmsVendor': '¿Eliminar el vendor PMS {name}?',
  'reception.tab.events': 'Eventos',
  'reception.actions.sendEmail': 'Enviar por correo electrónico',
  'reception.message.emailed': 'Código {id} enviado por correo electrónico.',
  'events.kicker': 'Wi-Fi para eventos',
  'events.title': 'Crear y gestionar accesos para eventos',
  'events.name': 'Nombre del evento',
  'events.hall': 'Sala del evento',
  'events.duration': 'Duración',
  'events.code': 'Código del evento',
  'events.isolation': 'Aislamiento de clientes',
  'events.network.loading': 'Cargando redes...',
  'events.network.empty': 'No hay redes disponibles',
  'events.network.loadError': 'No se pudieron cargar las redes',
  'events.isolated': 'Aislado',
  'events.shared': 'Acceso compartido',
  'events.policy': 'Política',
  'events.contactName': 'Nombre de contacto',
  'events.create': 'Nuevo evento',
  'events.edit': 'Editar evento',
  'events.sendEmail': 'Enviar el código por correo electrónico',
  'events.disable': 'Desactivar evento',
  'events.empty': 'No hay eventos configurados para esta ubicación.',
  'reception.tab.hotel': 'Hotel', 'reception.hotel.description': 'Códigos de habitaciones y zonas comunes desde PMS o Conserjería', 'reception.hotel.kicker': 'Códigos Wi-Fi del hotel', 'reception.hotel.title': 'Gestionar códigos de habitaciones y zonas comunes',
  'admin.onboarding.kicker': 'Alta guiada de ubicación', 'admin.onboarding.title': 'Crear y configurar una nueva ubicación', 'admin.onboarding.description': 'Sigue en orden el traspaso del proveedor a Lumen.',
  'admin.onboarding.step1': 'Controlador', 'admin.onboarding.step2': 'Ubicación', 'admin.onboarding.step3': 'Integraciones', 'admin.onboarding.step4': 'Revisión', 'admin.onboarding.step5': 'Revisión',
  'admin.onboarding.locationKicker': 'Paso 2 · Datos de ubicación', 'admin.onboarding.locationTitle': 'Introducir los datos de la nueva ubicación',
  'admin.onboarding.controllerKicker': 'Paso 1 · Conexión con proveedor', 'admin.onboarding.controllerTitle': 'Configurar el controlador de la ubicación', 'admin.onboarding.controllerHelp': 'El hardware, RF, grupos AP y SSID base deben existir en la plataforma del proveedor.',
  'admin.onboarding.integrationsKicker': 'Paso 3 · Integraciones opcionales', 'admin.onboarding.integrationsTitle': 'Configurar PMS, TV y correo', 'admin.onboarding.reviewKicker': 'Paso 4 · Revisión', 'admin.onboarding.reviewTitle': 'Confirmar la configuración', 'admin.onboarding.unitsNext': 'Después de guardar, configure habitaciones, unidades compartidas y salas de eventos con VLAN y redes.', 'admin.onboarding.saveContinue': 'Guardar y configurar unidades',
  'reception.fields.selectSpace': 'Seleccionar una unidad',
  'reception.category.journalist': 'Periodista',
  'reception.category.relator': 'Ponente',
  'reception.categoryDescription.staff': 'El código se crea en la VLAN predefinida.',
  'reception.categoryDescription.iot': 'El código se crea en la VLAN predefinida.',
  'reception.categoryDescription.visitor': 'El código se crea en la VLAN predefinida.',
  'reception.categoryDescription.guest': 'Selecciona la habitación para asociar su VLAN.',
  'events.message.saved': 'Evento {name} guardado.',
  'events.message.emailSent': 'Código del evento enviado a {email}.',
  'events.message.disabled': 'Evento {name} deshabilitado.',
  'events.codes.kicker': 'Gestión de huéspedes y visitantes',
  'events.codes.manage': 'Gestionar códigos del evento',
  'events.codes.type': 'Tipo de código',
  'events.codes.mode': 'Modo de creación',
  'events.codes.personal': 'Personal',
  'events.codes.manual': 'Manual',
  'events.codes.bulk': 'Importación masiva',
  'events.codes.personalManual': 'Personal · Manual',
  'events.codes.personalBulk': 'Personal · Importación masiva',
  'events.codes.group': 'Grupo',
  'events.codes.manualTitle': 'Crear un código personal',
  'events.codes.bulkTitle': 'Importar códigos personales desde CSV',
  'events.codes.groupTitle': 'Crear un código de grupo',
  'events.codes.groupName': 'Nombre del grupo',
  'events.codes.sendEmail': 'Enviar el código por correo electrónico',
  'events.codes.service': 'Servicio',
  'events.codes.serviceHint': 'Usa la VLAN de servicio configurada para la sala del evento.',
  'events.codes.serviceUnavailable': 'La sala seleccionada no tiene una VLAN de servicio configurada.',
  'events.codes.bulkHint': 'Columnas obligatorias: firstName, lastName, email, category, devicesAllowed. La duración y la sala se heredan del evento; el procesamiento se pone en cola para respetar los límites de solicitudes del proveedor.',
  'events.codes.createPersonal': 'Crear código personal',
  'events.codes.createGroup': 'Crear código de grupo',
  'events.codes.queueBulk': 'Poner en cola la importación CSV',
  'events.codes.personalCreated': 'Código personal creado: {code}',
  'events.codes.groupCreated': 'Código de grupo creado: {code}',
  'events.codes.bulkQueued': 'Importación {id} en cola: {imported} códigos procesados.',
  'admin.unitsBulk.action': 'Importación masiva',
  'admin.unitsBulk.kicker': 'Importación masiva de unidades',
  'admin.unitsBulk.title': 'Importar unidades desde CSV',
  'admin.unitsBulk.description': 'Crea habitaciones, zonas compartidas y salas de eventos en una sola operación.',
  'admin.unitsBulk.loadFile': 'Cargar CSV',
  'admin.unitsBulk.csv': 'CSV de unidades',
  'admin.unitsBulk.hint': 'Columnas: name, type, vlanId, serviceVlanId, networkId, panMode, capacity, assignment, status. Obligatorias: name, type, vlanId, networkId.',
  'admin.unitsBulk.importing': 'Importando...',
  'admin.unitsBulk.import': 'Importar unidades',
  'admin.unitsBulk.completed': '{count} unidades importadas.',
  'admin.unitsBulk.invalid': 'CSV no válido: {error}',
  'admin.unitsBulk.noRows': 'No se encontraron filas de datos.',
  'admin.unitsBulk.missingColumns': 'Faltan columnas: {columns}.',
  'admin.unitsBulk.rowError': 'Valores no válidos en la fila {row}.',
};
